import { axiosBaseQuery } from "@api/base-services-axios-rtx";
import { createApi } from "@reduxjs/toolkit/query/react";

import { createQuery } from "@/shared/helpers/create-query.helper";
import { ReviewsEndpoints } from "@/shared/models/endpoints/reviews.endpoint";
import { IListReviewsResponse } from "@/shared/models/interfaces/response/reviews/list-reviews.response";

export const ReviewsQueryServices = createApi({
  reducerPath: "Reviews-services",
  baseQuery: axiosBaseQuery(),

  endpoints: builder => ({
    getReviews: builder.mutation({
      query: (values: IValuesGetReviews) => ({
        url: ReviewsEndpoints.list + createQuery(values.filters),
        method: "GET"
      }),
      transformResponse: (response: IListReviewsResponse, meta, arg) => {
        return response.data;
      }
    })
  })
});

export const { useGetReviewsMutation } = ReviewsQueryServices;

export interface IValuesGetReviews {
  filters: IValuesGetReviewsFilters;
}

export interface IValuesGetReviewsFilters {
  authorId?: number;
  own?: boolean;
  page?: number;
  agent?: number;
}

// https://api-stage.remaxrd.com/v2/admin/reviews?authorId=62&own=true&page=1
// https://api-stage.remaxrd.com/v2/admin/reviews?agent=62&own=false&page=1
